import { throttle } from '@webikon/webentor-core/_utils';

document.addEventListener('DOMContentLoaded', function () {
  // Add the sticky class to the navbar when you reach its scroll position. Remove "sticky" when you leave the scroll position
  const navbar = document.getElementById('js-anchored-nav');

  if (!navbar) {
    return;
  }

  const sticky = navbar.offsetTop;

  function toggleStickyNav() {
    if (window.scrollY >= sticky) {
      navbar.classList.add('is-sticky');
    } else {
      navbar.classList.remove('is-sticky');
    }
  }

  window.addEventListener('scroll', throttle(toggleStickyNav));

  // Check if hrefs with anchors on navItems are contained as HTML ids in the DOM and show them
  const navItems = navbar.querySelectorAll('.js-anchored-nav-item');
  navItems.forEach((navItem) => {
    const anchor = navItem.getAttribute('href').replace('#', '');
    const target = document.getElementById(anchor);
    if (target) {
      navItem.classList.remove('hidden!');
      navItem.classList.add('inline-block');

      document.addEventListener(
        'scroll',
        throttle(() => {
          const scrollPosition =
            document.documentElement.scrollTop || document.body.scrollTop;

          if (
            target.getBoundingClientRect().top + window.scrollY - 130 <=
            scrollPosition
          ) {
            document
              .querySelector('.js-anchored-nav-item.is-active')
              ?.classList.remove('is-active');

            navItem.classList.add('is-active');
          }
        }),
      );
    }

    // Smooth scrolling with offset
    navItem.addEventListener('click', function (e) {
      e.preventDefault();
      const target = document.getElementById(anchor);
      if (target) {
        window.scrollTo({
          top: target.offsetTop - navbar.offsetHeight,
          behavior: 'smooth',
        });
      }
    });
  });
});
